module.exports = __webpack_public_path__ + "static/winter2-77c137de7519f41c5c741171ba64ca88.jpg";